<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentcolor">
    <path
      d="M19.147 6H9.023c-.63 0-1.231.315-1.584.84L2 14.893v2.662h8.11c.592 0 1.155-.276 1.518-.753l6.25-8.207 2.28 8.264L22 16.353 19.147 6ZM6.77 15.647H3.794l2.977-4.399v4.399Zm3.34 0H8.679V7.908h7.338l-5.897 7.739h-.01Z"
    />
  </svg>
</template>

<script>
export default {};
</script>
